import React from 'react';
import { CalendarClock } from 'lucide-react';
import { leaseObjectLabel } from '../../Helpers/leaseUtils';
import { LeaseSummary } from './leasesView';
import { Lease } from '../../types/leases';

interface LeasesSummaryProps {
    summary: LeaseSummary;
    tenantName: (tenantKey: string) => string;
    /** Names the building on a deadline when the leases span several. */
    buildingName?: (buildingKey: string) => string;
    onOpenLease: (leaseKey: string) => void;
    /** The object as shown (with the unit's stairwell); defaults to leaseObjectLabel. */
    objectLabel?: (lease: Lease) => string;
}

/** Uppsägning senast for the filtered leases; nothing when none is coming up. The rent total is the table's Summa row. */
const LeasesSummary: React.FC<LeasesSummaryProps> = ({ summary, tenantName, buildingName, onOpenLease, objectLabel = leaseObjectLabel }) => {
    const { upcomingDeadlines } = summary;
    if (upcomingDeadlines.length === 0) return null;

    return (
        <div className="leases-summary">
            <div className="std-box leases-summary-tile">
                <span className="leases-summary-icon leases-summary-icon--muted"><CalendarClock size={18} /></span>
                <div className="leases-summary-tile-body">
                    <div className="leases-summary-tile-title">Uppsägning senast</div>
                    {upcomingDeadlines.map(({ lease, deadline }) => (
                        <div key={lease.key}>
                            <button type="button" className="leases-summary-link" onClick={() => onOpenLease(lease.key)}>
                                {deadline}
                            </button>{' '}· {tenantName(lease.tenantKey)} · {objectLabel(lease)}
                            {buildingName && <> · {buildingName(lease.buildingKey)}</>}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LeasesSummary;
